<template>
  <div>
    <h1 data-scroll-reveal>
      Places I've Studied
    </h1>
    <article data-scroll-group data-scroll-step="110">
      <p>Living and studying in different places has given me different perspectives on the world.</p>
      <ChapterRail :items="chapterItems" label="Study sections" />
      <div id="timeline" data-scroll-group data-scroll-step="140">
        <div data-scroll-group data-scroll-step="160">
          <section id="study-university" class="year" data-scroll-group data-scroll-step="170">
            <h3>BASc</h3>
            <section id="study-hong-kong">
              <h4>September 2022 - Present</h4>
              <ul>
                  <div class="image-wrapper">
                    <img src="/assets/img/hku.jpeg" style="height:8.5vh;">
                  </div>
                <li class="title">The University of Hong Kong</li>
                <li class="role">Bachelor of Arts and Sciences in Applied Artificial Intelligence</li>
                <li class="description">I'm a fourth-year student at <a href="https://www.hku.hk/" target="_blank" rel="noopener">the University of Hong Kong</a>, majoring in <a href="https://admissions.hku.hk/programmes/undergraduate-programmes/bachelor-of-arts-and-sciences-applied-artificial-intelligence" target="_blank" rel="noopener">Applied Artificial Intelligence</a>.</li>
                <li class="description">My coursework spans machine learning, deep learning, data science, algorithms, software engineering, probability, statistics, linear algebra, and multivariable calculus.</li>
                <li class="description">I was named to the Dean's Honours List.</li>
                <li class="description">Outside coursework, I served as a Student Representative on the CAES Staff-Student Consultative Committee and as a Student Peer Advisor, supporting newer students with study and career planning.</li>
                <SourceViewLinks source-id="education:the-university-of-hong-kong" />
              </ul>
            </section>
            <section id="study-melbourne">
              <h4>February 2025 - June 2025</h4>
              <ul>
                  <div class="image-wrapper">
                    <img src="/assets/img/umelb.jpg" style="height:7.5vh;">
                  </div>
                <li class="title">The University of Melbourne</li>
                <li class="role">Semester Exchange</li>
                <li class="description">I spent one semester at <a href="https://www.unimelb.edu.au/" target="_blank" rel="noopener">The University of Melbourne</a> through the HKU Worldwide Student Exchange Programme.</li>
                <li class="description">Relevant coursework: Optimisation, Machine Learning, and Principles of Finance.</li>
                <SourceViewLinks source-id="education:the-university-of-melbourne" />
              </ul>
            </section>
          </section>
          <section id="study-secondary" class="year" data-scroll-group data-scroll-step="170">
            <h3>IBDP</h3>
            <section id="study-shanghai">
              <h4>September 2017 - June 2022</h4>
              <ul>
                  <div class="image-wrapper">
                      <img src="/assets/img/shsid.png" style="height:7.5vh;">
                  </div>
                <li class="title">Shanghai High School International Division</li>
                <li class="role">International Baccalaureate</li>
                <li class="description">I completed junior high and high school at <a href="https://www.shsid.org/" target="_blank" rel="noopener">Shanghai High School International Division</a>, where I took the International Baccalaureate Diploma Programme.</li>
                <li class="description">For the IB Diploma, I studied computer science, mathematics, economics, physics, English, and Chinese.</li>
                <li class="description">I co-founded SHSID Musix Board, a school-wide platform for sharing opinions about popular music, and led the Coding Club.</li>
                <SourceViewLinks source-id="education:shanghai-high-school-international-division" />
              </ul>
            </section>
            <section id="study-havelock-north">
              <h4>July 2019 - August 2019</h4>
              <ul>
                  <div class="image-wrapper">
                      <img src="/assets/img/hnhs.png" style="height:9vh;">
                  </div>
                <li class="title">Havelock North High School</li>
                <li class="role">Visiting Student</li>
                <li class="description">I spent two months as a visiting student at <a href="https://www.hnhs.school.nz/" target="_blank" rel="noopener">Havelock North High School</a> in Hawke's Bay, New Zealand, attending regular classes with local students.</li>
                <li class="description">I studied English, calculus, statistics, chemistry, and physics.</li>
                <SourceViewLinks source-id="education:havelock-north-high-school" />
              </ul>
            </section>
          </section>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import scrollRevealMixin from '../mixins/scrollRevealMixin';
import ChapterRail from './ChapterRail.vue';
import SourceViewLinks from './ui/SourceViewLinks.vue';

export default {
  name: 'EducationTab',
  components: { ChapterRail, SourceViewLinks },
  mixins: [scrollRevealMixin],
  data() {
    return {
      chapterItems: [
        { id: 'study-hong-kong', label: 'Hong Kong', title: 'The University of Hong Kong' },
        { id: 'study-melbourne', label: 'Melbourne', title: 'The University of Melbourne' },
        { id: 'study-shanghai', label: 'Shanghai', title: 'Shanghai High School International Division' },
        { id: 'study-havelock-north', label: 'Havelock North', title: 'Havelock North High School' }
      ]
    };
  }
}
</script>

<style scoped>
    @import url('../assets/css/timeline.css');
</style>

<!-- ## Shibei Junior High School

<img src="/assets/img/shibei.png" style="height:8vh;">

Prior to that, I attended the Science Class at [Shibei Junior High School](http://www.sbc.edu.sh.cn/), known as the best junior high school class for STEM subjects in Shanghai.
 -->
